import script from "./weixiaomo.vue?vue&type=script&setup=true&lang=js"
export * from "./weixiaomo.vue?vue&type=script&setup=true&lang=js"

import "./weixiaomo.vue?vue&type=style&index=0&id=7782c67f&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7782c67f"]])

export default __exports__